.burgerButton {
  border-radius: 18px;
  min-width: 36px;
  min-height: 36px;
  background: var(--primitives-colors-brand-secondary);
  margin-left: 12px;
  padding: 0;
  outline: 0;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: var(--primitives-gradient-yellow);
  }

  svg {
    path {
      stroke: var(--semantic-colors-typography-inverse);
    }
  }
}